const setAriaAttribute = (elId, errorFieldName, success)=>{
  let el = document.getElementById(elId)
  el?.setAttribute('aria-invalid', success);
  el?.setAttribute('aria-describedBy', errorFieldName);
}


export const success_TextInput = (data, elId) => {
  const class1 = document.getElementById(`${data.textid1}`);
  const class2 = document.getElementById(`${data.textid2}`);
  const class4 = document.getElementById(`${data.textid4}`);//success
  const class5 = document.getElementById(`${data.textid5}`);//error

  class1.classList.remove('cb-validation-error');
  class2.classList.remove('cb-validation-label-input');
  class5.classList.remove('cb-input-helper');
  class5.classList.remove('cb-validation-error');
  class5.style.display='none';

  class2.classList.add('cb-validation-label-input');
  class4.classList.add('cb-input-helper');
  class4.classList.add('cb-icon');
  class4.classList.add('cb-check-fill');
  class4.classList.add('cb-green1-color');
  //class4.style.display='block';

  setAriaAttribute(elId, data.textid4, false);
};

export const error_TextInput = (data, elId) => {
  const class1 = document.getElementById(`${data.textid1}`);
  const class2 = document.getElementById(`${data.textid2}`);
  const class4 = document.getElementById(`${data.textid4}`);
  const class5 = document.getElementById(`${data.textid5}`);

  class1.classList.remove('cb-icon');
  class1.classList.remove('cb-check-fill');
  class1.classList.remove('cb-green1-color');
  class2.classList.remove('cb-validation-label-input');
  class4.classList.remove('cb-input-helper');
  class4.classList.remove('cb-icon');
  class4.classList.remove('cb-check-fill');
  class4.classList.remove('cb-green1-color');
  class4.style.display='none';

  class1.classList.add('cb-validation-error');
  class2.classList.add('cb-validation-label-input');
  class5.classList.add('cb-input-helper');
  class5.classList.add('cb-validation-error');
  class5.style.display='block';

  setAriaAttribute(elId, data.textid5, true);
};

export const success_Select = (data, elId) => {
  const class1 = document.getElementById(`selectid1-${elId}`);
  const class2 = document.getElementById(`selectid2-${elId}`);
  const class4 = document.getElementById(`selectid4-${elId}`);
  const class5 = document.getElementById(`selectid5-${elId}`);

  setAriaAttribute(elId, `selectid4-${elId}`, false);
  if(data) {
    class1.classList.remove('cb-validation-error');
    class2.classList.remove('cb-validation-label-input');
    class5.classList.remove('cb-input-helper');
    class5.classList.remove('cb-validation-error');
    class5.style.display='none';

    class2.classList.add('cb-validation-label-input');
    class4.classList.add('cb-input-helper');
    class4.classList.add('cb-icon');
    class4.classList.add('cb-check-fill');
    class4.classList.add('cb-green1-color');
    //class4.style.display='block';
  } else {
    class1.classList.remove('cb-icon');
    class1.classList.remove('cb-check-fill');
    class1.classList.remove('cb-green1-color');
    class2.classList.remove('cb-validation-label-input');
    class4.classList.remove('cb-input-helper');
    class4.classList.remove('cb-icon');
    class4.classList.remove('cb-check-fill');
    class4.classList.remove('cb-green1-color');
    class4.style.display='none';
  }
};

export const error_Select = (data, elId) => {
  const class1 = document.getElementById(`selectid1-${elId}`);
  const class2 = document.getElementById(`selectid2-${elId}`);
  const class4 = document.getElementById(`selectid4-${elId}`);
  const class5 = document.getElementById(`selectid5-${elId}`);

  setAriaAttribute(elId, `selectid5-${elId}`, true);

  class4.style.display='none';
  if(data.length>1) {
    class1.classList.remove('cb-validation-error');
    class2.classList.remove('cb-validation-label-input');
    class5.classList.remove('cb-input-helper');
    class5.classList.remove('cb-validation-error');
    class5.style.display='none';

  } else {
    class1.classList.add('cb-validation-error');
    class2.classList.add('cb-validation-label-input');
    class5.classList.add('cb-input-helper');
    class5.classList.add('cb-validation-error');
    class5.style.display='block';
  }
};